import React, { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { showNotification } from './Notification';

function UpdateProfileModal({ isOpen, onClose }) {
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const { user, updateUserData } = useAuth();

  // Função para formatar telefone brasileiro
  const formatPhone = (value) => {
    // Remove tudo que não é número
    const numbers = value.replace(/\D/g, '');
    
    // Limita a 11 dígitos (DDD + 9 dígitos)
    const limitedNumbers = numbers.slice(0, 11);
    
    // Aplica a formatação
    if (limitedNumbers.length <= 2) {
      return limitedNumbers;
    } else if (limitedNumbers.length <= 7) {
      return `(${limitedNumbers.slice(0, 2)}) ${limitedNumbers.slice(2)}`;
    } else if (limitedNumbers.length <= 11) {
      return `(${limitedNumbers.slice(0, 2)}) ${limitedNumbers.slice(2, 7)}-${limitedNumbers.slice(7)}`;
    }
    
    return limitedNumbers;
  };

  // Função para lidar com mudança no telefone
  const handlePhoneChange = (e) => {
    const formatted = formatPhone(e.target.value);
    setPhone(formatted);
  };

  // Inicializa os campos quando o usuário é carregado ou modal abre
  useEffect(() => {
    if (user && isOpen) {
      setName(user.name || '');
      // Formata o telefone se existir
      const phoneValue = user.phone || '';
      setPhone(phoneValue ? formatPhone(phoneValue) : '');
    }
  }, [user, isOpen]);

  const handleSaveProfile = async () => {
    try {
      await updateUserData(user.uid, {
        name: name.trim(),
        phone: phone.trim()
      });
      
      showNotification('Perfil atualizado com sucesso!', 'success', 3000);
      onClose();
    } catch (error) {
      console.error('Erro ao atualizar perfil:', error);
      showNotification('Erro ao atualizar perfil. Tente novamente.', 'error', 5000);
    }
  };

  const handleCancel = () => {
    // Restaura os valores originais
    setName(user?.name || '');
    const phoneValue = user?.phone || '';
    setPhone(phoneValue ? formatPhone(phoneValue) : '');
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black bg-opacity-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-md">
        <h3 className="text-lg font-semibold mb-4">Atualizar Perfil</h3>
        
        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Nome
            </label>
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="w-full border border-gray-300 rounded-lg p-2.5 text-sm focus:ring-1 focus:ring-primary focus:border-primary focus:border outline-none transition-colors"
              placeholder="Digite seu nome completo"
            />
          </div>
          
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Telefone
            </label>
            <input
              type="tel"
              value={phone}
              onChange={handlePhoneChange}
              className="w-full border border-gray-300 rounded-lg p-2.5 text-sm focus:ring-1 focus:ring-primary focus:border-primary focus:border outline-none transition-colors"
              placeholder="(11) 99999-9999"
              maxLength={15}
            />
          </div>
        </div>
        
        <div className="flex gap-3 mt-6">
          <button
            onClick={handleSaveProfile}
            className="flex-1 bg-primary text-white py-2 px-4 rounded-lg hover:bg-primary-hover transition-colors"
          >
            Salvar
          </button>
          <button
            onClick={handleCancel}
            className="flex-1 bg-gray-200 text-gray-700 py-2 px-4 rounded-lg hover:bg-gray-300 transition-colors"
          >
            Cancelar
          </button>
        </div>
      </div>
    </div>
  );
}

export default UpdateProfileModal;
